import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'buscarCircular'
})
export class BuscarCircularPipe implements PipeTransform {

  transform(value: any[], dato: any): any[] {
    
    let newArr = []
    for(let i of value){
      if(i.Descripcion.toLocaleLowerCase().indexOf(dato.toLocaleLowerCase())>-1 ||
      i.Categoria.toLocaleLowerCase().indexOf(dato.toLocaleLowerCase())>-1 ||
      this.Destinado(i.Destinos, dato)){
        newArr.push(i)
      }
    }

    return newArr;
  }


  Destinado(array: Array<any>, seccion){
    for(let i of array){
      if(String(i) == String(seccion)){
        return true;
      }
    }
    return false;
  }
}
